import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "eggman_token_v1";

export const api = axios.create({ baseURL: `${BASE}/api` });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// Auto sign-out on 401/403 from authenticated endpoints — happens when the
// server-side JWT secret has rotated since this browser was last issued a token.
// Don't redirect on /auth/login itself (would create a loop).
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const code = err?.response?.status;
    const url = err?.config?.url || "";
    const wasAuthed = !!localStorage.getItem(TOKEN_KEY);
    const isAuthRoute = url.includes("/auth/login") || url.includes("/auth/signup");
    if (wasAuthed && code === 401 && !isAuthRoute) {
      localStorage.removeItem(TOKEN_KEY);
      // Soft redirect — use replace so back-button doesn't trap the user.
      if (typeof window !== "undefined") {
        const next = encodeURIComponent(window.location.pathname + window.location.search);
        window.location.replace(`/login?next=${next}&reason=session_expired`);
      }
    }
    return Promise.reject(err);
  }
);

export const setToken = (t) => {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
};

export const getToken = () => localStorage.getItem(TOKEN_KEY);
